









import Vue from "vue";
import SvgIcon from "@/components/SvgIcon.vue";

export default Vue.extend({ components: { SvgIcon } });
